import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RestockSessionSummaryFragment = { __typename?: 'RestockSessionDocument', sessionId: string, sessionName: string, shipDate: Types.TDateISO, status: Types.RestockSessionStatus, storeCount: number, totalQuantity: number, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy?: string | null };

export type RestockSessionStoreFragment = { __typename?: 'RestockSessionStoreData', customerLocationId: string, storeName: string };

export type RestockSessionDetailsFragment = { __typename?: 'RestockSessionStateData', sessionId: string, sessionName: string, shipDate: Types.TDateISO, status: Types.RestockSessionStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, selectedItemIds: Array<string>, stationCode?: string | null, targetWeeksOfSupply?: number | null, stores: Array<{ __typename?: 'RestockSessionStoreData', customerLocationId: string, storeName: string }>, reserveRules: Array<{ __typename?: 'RestockSessionReserveRuleData', id: string, level: string, mode: string, name: string, percentage: number, value: string }> };

export type GetRestockSessionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.RestockSessionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.RestockSessionDocumentSortInput> | Types.RestockSessionDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRestockSessionsQuery = { __typename?: 'Query', restockSessions?: { __typename?: 'RestockSessionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'RestockSessionDocument', sessionId: string, sessionName: string, shipDate: Types.TDateISO, status: Types.RestockSessionStatus, storeCount: number, totalQuantity: number, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRestockSessionQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
}>;


export type GetRestockSessionQuery = { __typename?: 'Query', restockSession?: { __typename?: 'RestockSessionStateData', sessionId: string, sessionName: string, shipDate: Types.TDateISO, status: Types.RestockSessionStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, selectedItemIds: Array<string>, stationCode?: string | null, targetWeeksOfSupply?: number | null, stores: Array<{ __typename?: 'RestockSessionStoreData', customerLocationId: string, storeName: string }>, reserveRules: Array<{ __typename?: 'RestockSessionReserveRuleData', id: string, level: string, mode: string, name: string, percentage: number, value: string }> } | null };

export type GetRestockSessionCalcStatusQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
}>;


export type GetRestockSessionCalcStatusQuery = { __typename?: 'Query', restockSession?: { __typename?: 'RestockSessionStateData', sessionId: string, calculationStatus: Types.RestockCalculationStatus, lastCalculationError: string, lastRequestId?: string | null, requestedRowCount?: number | null, resolvedRowCount?: number | null } | null };

export type RestockSessionOrderItemDocFragment = { __typename?: 'RestockSessionOrderItemDocument', achievableQuantity?: number | null, allocatedValue: number, available: number, availableValue: number, blockingRuleIds: Array<string>, calculatedOrderQuantity: number, calculatedAt?: Types.TDateISO | null, carts: number, categories?: Array<string> | null, city?: string | null, customerLocationId: string, daysSinceLastDelivery: number, daysSinceLastSale: number, demandQuantity: number, description: string, hasOverrides: boolean, id: string, inTransit: number, itemGroup?: string | null, itemId: string, itemName: string, itemNumber: string, orderQuantity: number, predictedOnHand: number, previousOrderQuantity?: number | null, productGroup?: string | null, containerCode?: string | null, shipmentIncrement: number, programs?: Array<string> | null, promotionRuleIds: Array<string>, route?: string | null, sellDownUnits: number, sessionId: string, stateProvince?: string | null, storeClass?: string | null, storeName: string, subcategory?: string | null, targetOnHand: number, trailingSales: number, rawTrailingUnitsSold: number, usableTrailingUnitsSold: number, weeklyRateOfSale: number, unitValue: number, unitsOnHand: number, unitsOnHandValue: number, unitsReplenished: number, weeksOfSupply: number, lastCycleCountAt?: Types.TDateISO | null, onHandConfidencePercent: number, deliveryDate?: Types.TDateISO | null, replenishmentTarget: number, reservePercent: number, allocatePercent: number, greenhouseInventory?: number | null, reserveQuantity: number, availableToShip: number, overallStatus: string, location?: { __typename?: 'CustomerLocationDocument', code: string, storeNumber: string, region: string, market: string, address?: { __typename?: 'AddressData', city: string, stateProvince: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', storeClass: string, route: string, deliveryScheduleId: string, zone: string, retailerName: string } | null } | null };

export type GetRestockSessionOrderItemsQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  where?: Types.InputMaybe<Types.RestockSessionOrderItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.RestockSessionOrderItemDocumentSortInput> | Types.RestockSessionOrderItemDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRestockSessionOrderItemsQuery = { __typename?: 'Query', restockSessionOrderItems?: { __typename?: 'RestockSessionOrderItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'RestockSessionOrderItemDocument', achievableQuantity?: number | null, allocatedValue: number, available: number, availableValue: number, blockingRuleIds: Array<string>, calculatedOrderQuantity: number, calculatedAt?: Types.TDateISO | null, carts: number, categories?: Array<string> | null, city?: string | null, customerLocationId: string, daysSinceLastDelivery: number, daysSinceLastSale: number, demandQuantity: number, description: string, hasOverrides: boolean, id: string, inTransit: number, itemGroup?: string | null, itemId: string, itemName: string, itemNumber: string, orderQuantity: number, predictedOnHand: number, previousOrderQuantity?: number | null, productGroup?: string | null, containerCode?: string | null, shipmentIncrement: number, programs?: Array<string> | null, promotionRuleIds: Array<string>, route?: string | null, sellDownUnits: number, sessionId: string, stateProvince?: string | null, storeClass?: string | null, storeName: string, subcategory?: string | null, targetOnHand: number, trailingSales: number, rawTrailingUnitsSold: number, usableTrailingUnitsSold: number, weeklyRateOfSale: number, unitValue: number, unitsOnHand: number, unitsOnHandValue: number, unitsReplenished: number, weeksOfSupply: number, lastCycleCountAt?: Types.TDateISO | null, onHandConfidencePercent: number, deliveryDate?: Types.TDateISO | null, replenishmentTarget: number, reservePercent: number, allocatePercent: number, greenhouseInventory?: number | null, reserveQuantity: number, availableToShip: number, overallStatus: string, location?: { __typename?: 'CustomerLocationDocument', code: string, storeNumber: string, region: string, market: string, address?: { __typename?: 'AddressData', city: string, stateProvince: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', storeClass: string, route: string, deliveryScheduleId: string, zone: string, retailerName: string } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type RestockOrderItemGroupTotalFragment = { __typename?: 'RestockOrderItemGroupTotal', groupKeyValues: Array<string>, rowCount: number, orderQuantity: number, demandQuantity: number, achievableQuantity: number, unitsOnHand: number, available: number };

export type GetRestockSessionOrderItemsBlockQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  offset: Types.Scalars['Int']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sort?: Types.InputMaybe<Array<Types.RestockOrderItemSortInput> | Types.RestockOrderItemSortInput>;
  filter?: Types.InputMaybe<Types.RestockOrderItemFilterInput>;
  groupBy?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  groupKeys?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type GetRestockSessionOrderItemsBlockQuery = { __typename?: 'Query', restockSessionOrderItemsBlock: { __typename?: 'RestockSessionOrderItemsBlockPayload', totalCount: number, nodes: Array<{ __typename?: 'RestockSessionOrderItemDocument', achievableQuantity?: number | null, allocatedValue: number, available: number, availableValue: number, blockingRuleIds: Array<string>, calculatedOrderQuantity: number, calculatedAt?: Types.TDateISO | null, carts: number, categories?: Array<string> | null, city?: string | null, customerLocationId: string, daysSinceLastDelivery: number, daysSinceLastSale: number, demandQuantity: number, description: string, hasOverrides: boolean, id: string, inTransit: number, itemGroup?: string | null, itemId: string, itemName: string, itemNumber: string, orderQuantity: number, predictedOnHand: number, previousOrderQuantity?: number | null, productGroup?: string | null, containerCode?: string | null, shipmentIncrement: number, programs?: Array<string> | null, promotionRuleIds: Array<string>, route?: string | null, sellDownUnits: number, sessionId: string, stateProvince?: string | null, storeClass?: string | null, storeName: string, subcategory?: string | null, targetOnHand: number, trailingSales: number, rawTrailingUnitsSold: number, usableTrailingUnitsSold: number, weeklyRateOfSale: number, unitValue: number, unitsOnHand: number, unitsOnHandValue: number, unitsReplenished: number, weeksOfSupply: number, lastCycleCountAt?: Types.TDateISO | null, onHandConfidencePercent: number, deliveryDate?: Types.TDateISO | null, replenishmentTarget: number, reservePercent: number, allocatePercent: number, greenhouseInventory?: number | null, reserveQuantity: number, availableToShip: number, overallStatus: string, location?: { __typename?: 'CustomerLocationDocument', code: string, storeNumber: string, region: string, market: string, address?: { __typename?: 'AddressData', city: string, stateProvince: string } | null, settings?: { __typename?: 'CustomerLocationSettingsDocument', storeClass: string, route: string, deliveryScheduleId: string, zone: string, retailerName: string } | null } | null }>, groupTotals: Array<{ __typename?: 'RestockOrderItemGroupTotal', groupKeyValues: Array<string>, rowCount: number, orderQuantity: number, demandQuantity: number, achievableQuantity: number, unitsOnHand: number, available: number }> } };

export type RestockCalcStepDocumentFieldsFragment = { __typename?: 'RestockCalcStepDocument', code: string, severity: string, message: string, context: Array<{ __typename?: 'RestockCalcStepContextDocument', key: string, value: string }> };

export type GetRestockSessionRowCalcStepsQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  itemId: Types.Scalars['String']['input'];
  locationId: Types.Scalars['String']['input'];
}>;


export type GetRestockSessionRowCalcStepsQuery = { __typename?: 'Query', restockSessionRowCalcSteps: Array<{ __typename?: 'RestockCalcStepDocument', code: string, severity: string, message: string, context: Array<{ __typename?: 'RestockCalcStepContextDocument', key: string, value: string }> }> };

export type RestockFullCartRowFieldsFragment = { __typename?: 'RestockFullCartRowData', itemId: string, customerLocationId: string, itemName: string, storeName: string, orderQuantity: number, roundedOrderQuantity: number, unitsPerCart?: number | null };

export type RestockFullCartPreviewFieldsFragment = { __typename?: 'RestockFullCartPreviewData', sessionId: string, selectedStoreCount: number, storesNotInSession: Array<string>, sessionStoreCount: number, wholeSession: boolean, rowCount: number, increasedRowCount: number, increasedQuantity: number, decreasedRowCount: number, decreasedQuantity: number, unchangedRowCount: number, skippedRowCount: number, orderQuantityBefore: number, orderQuantityAfter: number, sourceToken: string, sourceChanged?: boolean | null, skips: Array<{ __typename?: 'RestockFullCartSkipData', reason: Types.RestockFullCartSkipReason, rowCount: number, examples: Array<{ __typename?: 'RestockFullCartRowData', itemId: string, customerLocationId: string, itemName: string, storeName: string, orderQuantity: number, roundedOrderQuantity: number, unitsPerCart?: number | null }> }>, changes: Array<{ __typename?: 'RestockFullCartRowData', itemId: string, customerLocationId: string, itemName: string, storeName: string, orderQuantity: number, roundedOrderQuantity: number, unitsPerCart?: number | null }> };

export type GetRestockFullCartPreviewQueryVariables = Types.Exact<{
  input: Types.RestockFullCartPreviewInput;
}>;


export type GetRestockFullCartPreviewQuery = { __typename?: 'Query', restockFullCartPreview: { __typename?: 'RestockFullCartPreviewPayload', preview?: { __typename?: 'RestockFullCartPreviewData', sessionId: string, selectedStoreCount: number, storesNotInSession: Array<string>, sessionStoreCount: number, wholeSession: boolean, rowCount: number, increasedRowCount: number, increasedQuantity: number, decreasedRowCount: number, decreasedQuantity: number, unchangedRowCount: number, skippedRowCount: number, orderQuantityBefore: number, orderQuantityAfter: number, sourceToken: string, sourceChanged?: boolean | null, skips: Array<{ __typename?: 'RestockFullCartSkipData', reason: Types.RestockFullCartSkipReason, rowCount: number, examples: Array<{ __typename?: 'RestockFullCartRowData', itemId: string, customerLocationId: string, itemName: string, storeName: string, orderQuantity: number, roundedOrderQuantity: number, unitsPerCart?: number | null }> }>, changes: Array<{ __typename?: 'RestockFullCartRowData', itemId: string, customerLocationId: string, itemName: string, storeName: string, orderQuantity: number, roundedOrderQuantity: number, unitsPerCart?: number | null }> } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };

export type RestockExplanationPayloadFieldsFragment = { __typename?: 'RestockExplanationPayload', providerKey: string, modelVersion: string, payload: string, overflowed: boolean, writtenAt: Types.TDateISO };

export type GetRestockRowExplanationQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  storeSkuKey: Types.Scalars['String']['input'];
}>;


export type GetRestockRowExplanationQuery = { __typename?: 'Query', restockRowExplanation?: { __typename?: 'RestockExplanationPayload', providerKey: string, modelVersion: string, payload: string, overflowed: boolean, writtenAt: Types.TDateISO } | null };

export type RestockSessionCreationExclusionsFieldsFragment = { __typename?: 'RestockSessionCreationExclusionsPayload', sessionId: string, excludedTupleCount: number, excludedItemCount: number, excludedItemCodes: Array<string>, occurredAt: Types.TDateISO };

export type GetRestockSessionCreationExclusionsQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
}>;


export type GetRestockSessionCreationExclusionsQuery = { __typename?: 'Query', restockSessionCreationExclusions?: { __typename?: 'RestockSessionCreationExclusionsPayload', sessionId: string, excludedTupleCount: number, excludedItemCount: number, excludedItemCodes: Array<string>, occurredAt: Types.TDateISO } | null };

export type RestockSessionOrderQuantityOverrideHistoryRowFragment = { __typename?: 'RestockSessionOrderQuantityOverrideHistoryDocument', id: string, occurredAt: Types.TDateISO, sequence: number, updatedBy: string, overrideKind: Types.OverrideKind, orderQuantity: number, previousOrderQuantity?: number | null, bulkOperand?: number | null };

export type GetRestockSessionOrderQuantityOverrideHistoryQueryVariables = Types.Exact<{
  restockSessionId: Types.Scalars['String']['input'];
  itemId: Types.Scalars['String']['input'];
  customerLocationId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRestockSessionOrderQuantityOverrideHistoryQuery = { __typename?: 'Query', restockSessionOrderQuantityOverrideHistory?: { __typename?: 'RestockSessionOrderQuantityOverrideHistoryConnection', totalCount: number, nodes?: Array<{ __typename?: 'RestockSessionOrderQuantityOverrideHistoryDocument', id: string, occurredAt: Types.TDateISO, sequence: number, updatedBy: string, overrideKind: Types.OverrideKind, orderQuantity: number, previousOrderQuantity?: number | null, bulkOperand?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRestockSessionSubmitSummaryQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
}>;


export type GetRestockSessionSubmitSummaryQuery = { __typename?: 'Query', restockSessionSubmitSummary?: { __typename?: 'RestockSessionSubmitSummaryData', sessionId: string, storeCount: number, selectedItemCount: number, totalCarts: number, totalValue: number } | null };

export type RestockSessionKitLineFragment = { __typename?: 'RestockSessionKitLineData', lineId: string, kind: Types.KitLineKind, refId: string, multiple: number, label: string, secondaryLabel: string, unit?: { __typename?: 'RestockSessionKitLineUnitData', shippingUomId: string, shippingUomCode: string, eachesPerUnit: number } | null };

export type RestockSessionKitFragment = { __typename?: 'RestockSessionKitData', kitId: string, siteIds: Array<string>, definitions: Array<{ __typename?: 'RestockSessionKitDefinitionData', kitId: string, name: string, containerCode: string, sourceUpdatedAt: Types.TDateISO, lines: Array<{ __typename?: 'RestockSessionKitLineData', lineId: string, kind: Types.KitLineKind, refId: string, multiple: number, label: string, secondaryLabel: string, unit?: { __typename?: 'RestockSessionKitLineUnitData', shippingUomId: string, shippingUomCode: string, eachesPerUnit: number } | null }> }> };

export type GetRestockSessionKitsQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
}>;


export type GetRestockSessionKitsQuery = { __typename?: 'Query', restockSession?: { __typename?: 'RestockSessionStateData', sessionId: string, sessionName: string, status: Types.RestockSessionStatus, kits: Array<{ __typename?: 'RestockSessionKitData', kitId: string, siteIds: Array<string>, definitions: Array<{ __typename?: 'RestockSessionKitDefinitionData', kitId: string, name: string, containerCode: string, sourceUpdatedAt: Types.TDateISO, lines: Array<{ __typename?: 'RestockSessionKitLineData', lineId: string, kind: Types.KitLineKind, refId: string, multiple: number, label: string, secondaryLabel: string, unit?: { __typename?: 'RestockSessionKitLineUnitData', shippingUomId: string, shippingUomCode: string, eachesPerUnit: number } | null }> }> }> } | null };

export const RestockSessionSummaryFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionSummary on RestockSessionDocument {
  sessionId
  sessionName
  shipDate
  status
  storeCount
  totalQuantity
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"RestockSessionSummary"});
export const RestockSessionStoreFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionStore on RestockSessionStoreData {
  customerLocationId
  storeName
}
    `, {"fragmentName":"RestockSessionStore"});
export const RestockSessionDetailsFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionDetails on RestockSessionStateData {
  sessionId
  sessionName
  shipDate
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  selectedItemIds
  stationCode
  targetWeeksOfSupply
  stores {
    ...RestockSessionStore
  }
  reserveRules {
    id
    level
    mode
    name
    percentage
    value
  }
}
    fragment RestockSessionStore on RestockSessionStoreData {
  customerLocationId
  storeName
}`, {"fragmentName":"RestockSessionDetails"});
export const RestockSessionOrderItemDocFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionOrderItemDoc on RestockSessionOrderItemDocument {
  achievableQuantity
  allocatedValue
  available
  availableValue
  blockingRuleIds
  calculatedOrderQuantity
  calculatedAt
  carts
  categories
  city
  customerLocationId
  daysSinceLastDelivery
  daysSinceLastSale
  demandQuantity
  description
  hasOverrides
  id
  inTransit
  itemGroup
  itemId
  itemName
  itemNumber
  orderQuantity
  predictedOnHand
  previousOrderQuantity
  productGroup
  containerCode
  shipmentIncrement
  programs
  promotionRuleIds
  route
  sellDownUnits
  sessionId
  stateProvince
  storeClass
  storeName
  subcategory
  targetOnHand
  trailingSales
  rawTrailingUnitsSold
  usableTrailingUnitsSold
  weeklyRateOfSale
  unitValue
  unitsOnHand
  unitsOnHandValue
  unitsReplenished
  weeksOfSupply
  lastCycleCountAt
  onHandConfidencePercent
  deliveryDate
  replenishmentTarget
  reservePercent
  allocatePercent
  greenhouseInventory
  reserveQuantity
  availableToShip
  overallStatus
  location {
    code
    storeNumber
    region
    market
    address {
      city
      stateProvince
    }
    settings {
      storeClass
      route
      deliveryScheduleId
      zone
      retailerName
    }
  }
}
    `, {"fragmentName":"RestockSessionOrderItemDoc"});
export const RestockOrderItemGroupTotalFragmentDoc = new TypedDocumentString(`
    fragment RestockOrderItemGroupTotal on RestockOrderItemGroupTotal {
  groupKeyValues
  rowCount
  orderQuantity
  demandQuantity
  achievableQuantity
  unitsOnHand
  available
}
    `, {"fragmentName":"RestockOrderItemGroupTotal"});
export const RestockCalcStepDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment RestockCalcStepDocumentFields on RestockCalcStepDocument {
  code
  severity
  message
  context {
    key
    value
  }
}
    `, {"fragmentName":"RestockCalcStepDocumentFields"});
export const RestockFullCartRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment RestockFullCartRowFields on RestockFullCartRowData {
  itemId
  customerLocationId
  itemName
  storeName
  orderQuantity
  roundedOrderQuantity
  unitsPerCart
}
    `, {"fragmentName":"RestockFullCartRowFields"});
export const RestockFullCartPreviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment RestockFullCartPreviewFields on RestockFullCartPreviewData {
  sessionId
  selectedStoreCount
  storesNotInSession
  sessionStoreCount
  wholeSession
  rowCount
  increasedRowCount
  increasedQuantity
  decreasedRowCount
  decreasedQuantity
  unchangedRowCount
  skippedRowCount
  orderQuantityBefore
  orderQuantityAfter
  skips {
    reason
    rowCount
    examples {
      ...RestockFullCartRowFields
    }
  }
  changes {
    ...RestockFullCartRowFields
  }
  sourceToken
  sourceChanged
}
    fragment RestockFullCartRowFields on RestockFullCartRowData {
  itemId
  customerLocationId
  itemName
  storeName
  orderQuantity
  roundedOrderQuantity
  unitsPerCart
}`, {"fragmentName":"RestockFullCartPreviewFields"});
export const RestockExplanationPayloadFieldsFragmentDoc = new TypedDocumentString(`
    fragment RestockExplanationPayloadFields on RestockExplanationPayload {
  providerKey
  modelVersion
  payload
  overflowed
  writtenAt
}
    `, {"fragmentName":"RestockExplanationPayloadFields"});
export const RestockSessionCreationExclusionsFieldsFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionCreationExclusionsFields on RestockSessionCreationExclusionsPayload {
  sessionId
  excludedTupleCount
  excludedItemCount
  excludedItemCodes
  occurredAt
}
    `, {"fragmentName":"RestockSessionCreationExclusionsFields"});
export const RestockSessionOrderQuantityOverrideHistoryRowFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionOrderQuantityOverrideHistoryRow on RestockSessionOrderQuantityOverrideHistoryDocument {
  id
  occurredAt
  sequence
  updatedBy
  overrideKind
  orderQuantity
  previousOrderQuantity
  bulkOperand
}
    `, {"fragmentName":"RestockSessionOrderQuantityOverrideHistoryRow"});
export const RestockSessionKitLineFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionKitLine on RestockSessionKitLineData {
  lineId
  kind
  refId
  multiple
  label
  secondaryLabel
  unit {
    shippingUomId
    shippingUomCode
    eachesPerUnit
  }
}
    `, {"fragmentName":"RestockSessionKitLine"});
export const RestockSessionKitFragmentDoc = new TypedDocumentString(`
    fragment RestockSessionKit on RestockSessionKitData {
  kitId
  siteIds
  definitions {
    kitId
    name
    containerCode
    sourceUpdatedAt
    lines {
      ...RestockSessionKitLine
    }
  }
}
    fragment RestockSessionKitLine on RestockSessionKitLineData {
  lineId
  kind
  refId
  multiple
  label
  secondaryLabel
  unit {
    shippingUomId
    shippingUomCode
    eachesPerUnit
  }
}`, {"fragmentName":"RestockSessionKit"});
export const GetRestockSessionsDocument = new TypedDocumentString(`
    query GetRestockSessions($where: RestockSessionDocumentFilterInput, $order: [RestockSessionDocumentSortInput!], $first: Int, $after: String) {
  restockSessions(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...RestockSessionSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment RestockSessionSummary on RestockSessionDocument {
  sessionId
  sessionName
  shipDate
  status
  storeCount
  totalQuantity
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRestockSessionDocument = new TypedDocumentString(`
    query GetRestockSession($sessionId: String!) {
  restockSession(sessionId: $sessionId) {
    ...RestockSessionDetails
  }
}
    fragment RestockSessionStore on RestockSessionStoreData {
  customerLocationId
  storeName
}
fragment RestockSessionDetails on RestockSessionStateData {
  sessionId
  sessionName
  shipDate
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  selectedItemIds
  stationCode
  targetWeeksOfSupply
  stores {
    ...RestockSessionStore
  }
  reserveRules {
    id
    level
    mode
    name
    percentage
    value
  }
}`);
export const GetRestockSessionCalcStatusDocument = new TypedDocumentString(`
    query GetRestockSessionCalcStatus($sessionId: String!) {
  restockSession(sessionId: $sessionId) {
    sessionId
    calculationStatus
    lastCalculationError
    lastRequestId
    requestedRowCount
    resolvedRowCount
  }
}
    `);
export const GetRestockSessionOrderItemsDocument = new TypedDocumentString(`
    query GetRestockSessionOrderItems($sessionId: String!, $where: RestockSessionOrderItemDocumentFilterInput, $order: [RestockSessionOrderItemDocumentSortInput!], $first: Int, $after: String) {
  restockSessionOrderItems(
    sessionId: $sessionId
    where: $where
    order: $order
    first: $first
    after: $after
  ) {
    nodes {
      ...RestockSessionOrderItemDoc
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment RestockSessionOrderItemDoc on RestockSessionOrderItemDocument {
  achievableQuantity
  allocatedValue
  available
  availableValue
  blockingRuleIds
  calculatedOrderQuantity
  calculatedAt
  carts
  categories
  city
  customerLocationId
  daysSinceLastDelivery
  daysSinceLastSale
  demandQuantity
  description
  hasOverrides
  id
  inTransit
  itemGroup
  itemId
  itemName
  itemNumber
  orderQuantity
  predictedOnHand
  previousOrderQuantity
  productGroup
  containerCode
  shipmentIncrement
  programs
  promotionRuleIds
  route
  sellDownUnits
  sessionId
  stateProvince
  storeClass
  storeName
  subcategory
  targetOnHand
  trailingSales
  rawTrailingUnitsSold
  usableTrailingUnitsSold
  weeklyRateOfSale
  unitValue
  unitsOnHand
  unitsOnHandValue
  unitsReplenished
  weeksOfSupply
  lastCycleCountAt
  onHandConfidencePercent
  deliveryDate
  replenishmentTarget
  reservePercent
  allocatePercent
  greenhouseInventory
  reserveQuantity
  availableToShip
  overallStatus
  location {
    code
    storeNumber
    region
    market
    address {
      city
      stateProvince
    }
    settings {
      storeClass
      route
      deliveryScheduleId
      zone
      retailerName
    }
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRestockSessionOrderItemsBlockDocument = new TypedDocumentString(`
    query GetRestockSessionOrderItemsBlock($sessionId: String!, $offset: Int!, $limit: Int, $sort: [RestockOrderItemSortInput!], $filter: RestockOrderItemFilterInput, $groupBy: [String!], $groupKeys: [String!]) {
  restockSessionOrderItemsBlock(
    sessionId: $sessionId
    offset: $offset
    limit: $limit
    sort: $sort
    filter: $filter
    groupBy: $groupBy
    groupKeys: $groupKeys
  ) {
    nodes {
      ...RestockSessionOrderItemDoc
    }
    totalCount
    groupTotals {
      ...RestockOrderItemGroupTotal
    }
  }
}
    fragment RestockSessionOrderItemDoc on RestockSessionOrderItemDocument {
  achievableQuantity
  allocatedValue
  available
  availableValue
  blockingRuleIds
  calculatedOrderQuantity
  calculatedAt
  carts
  categories
  city
  customerLocationId
  daysSinceLastDelivery
  daysSinceLastSale
  demandQuantity
  description
  hasOverrides
  id
  inTransit
  itemGroup
  itemId
  itemName
  itemNumber
  orderQuantity
  predictedOnHand
  previousOrderQuantity
  productGroup
  containerCode
  shipmentIncrement
  programs
  promotionRuleIds
  route
  sellDownUnits
  sessionId
  stateProvince
  storeClass
  storeName
  subcategory
  targetOnHand
  trailingSales
  rawTrailingUnitsSold
  usableTrailingUnitsSold
  weeklyRateOfSale
  unitValue
  unitsOnHand
  unitsOnHandValue
  unitsReplenished
  weeksOfSupply
  lastCycleCountAt
  onHandConfidencePercent
  deliveryDate
  replenishmentTarget
  reservePercent
  allocatePercent
  greenhouseInventory
  reserveQuantity
  availableToShip
  overallStatus
  location {
    code
    storeNumber
    region
    market
    address {
      city
      stateProvince
    }
    settings {
      storeClass
      route
      deliveryScheduleId
      zone
      retailerName
    }
  }
}
fragment RestockOrderItemGroupTotal on RestockOrderItemGroupTotal {
  groupKeyValues
  rowCount
  orderQuantity
  demandQuantity
  achievableQuantity
  unitsOnHand
  available
}`);
export const GetRestockSessionRowCalcStepsDocument = new TypedDocumentString(`
    query GetRestockSessionRowCalcSteps($sessionId: String!, $itemId: String!, $locationId: String!) {
  restockSessionRowCalcSteps(
    sessionId: $sessionId
    itemId: $itemId
    locationId: $locationId
  ) {
    ...RestockCalcStepDocumentFields
  }
}
    fragment RestockCalcStepDocumentFields on RestockCalcStepDocument {
  code
  severity
  message
  context {
    key
    value
  }
}`);
export const GetRestockFullCartPreviewDocument = new TypedDocumentString(`
    query GetRestockFullCartPreview($input: RestockFullCartPreviewInput!) {
  restockFullCartPreview(input: $input) {
    preview {
      ...RestockFullCartPreviewFields
    }
    errors {
      code
      message
    }
  }
}
    fragment RestockFullCartRowFields on RestockFullCartRowData {
  itemId
  customerLocationId
  itemName
  storeName
  orderQuantity
  roundedOrderQuantity
  unitsPerCart
}
fragment RestockFullCartPreviewFields on RestockFullCartPreviewData {
  sessionId
  selectedStoreCount
  storesNotInSession
  sessionStoreCount
  wholeSession
  rowCount
  increasedRowCount
  increasedQuantity
  decreasedRowCount
  decreasedQuantity
  unchangedRowCount
  skippedRowCount
  orderQuantityBefore
  orderQuantityAfter
  skips {
    reason
    rowCount
    examples {
      ...RestockFullCartRowFields
    }
  }
  changes {
    ...RestockFullCartRowFields
  }
  sourceToken
  sourceChanged
}`);
export const GetRestockRowExplanationDocument = new TypedDocumentString(`
    query GetRestockRowExplanation($sessionId: String!, $storeSkuKey: String!) {
  restockRowExplanation(sessionId: $sessionId, storeSkuKey: $storeSkuKey) {
    ...RestockExplanationPayloadFields
  }
}
    fragment RestockExplanationPayloadFields on RestockExplanationPayload {
  providerKey
  modelVersion
  payload
  overflowed
  writtenAt
}`);
export const GetRestockSessionCreationExclusionsDocument = new TypedDocumentString(`
    query GetRestockSessionCreationExclusions($sessionId: String!) {
  restockSessionCreationExclusions(sessionId: $sessionId) {
    ...RestockSessionCreationExclusionsFields
  }
}
    fragment RestockSessionCreationExclusionsFields on RestockSessionCreationExclusionsPayload {
  sessionId
  excludedTupleCount
  excludedItemCount
  excludedItemCodes
  occurredAt
}`);
export const GetRestockSessionOrderQuantityOverrideHistoryDocument = new TypedDocumentString(`
    query GetRestockSessionOrderQuantityOverrideHistory($restockSessionId: String!, $itemId: String!, $customerLocationId: String!, $first: Int, $after: String) {
  restockSessionOrderQuantityOverrideHistory(
    restockSessionId: $restockSessionId
    itemId: $itemId
    customerLocationId: $customerLocationId
    first: $first
    after: $after
  ) {
    nodes {
      ...RestockSessionOrderQuantityOverrideHistoryRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment RestockSessionOrderQuantityOverrideHistoryRow on RestockSessionOrderQuantityOverrideHistoryDocument {
  id
  occurredAt
  sequence
  updatedBy
  overrideKind
  orderQuantity
  previousOrderQuantity
  bulkOperand
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRestockSessionSubmitSummaryDocument = new TypedDocumentString(`
    query GetRestockSessionSubmitSummary($sessionId: String!) {
  restockSessionSubmitSummary(sessionId: $sessionId) {
    sessionId
    storeCount
    selectedItemCount
    totalCarts
    totalValue
  }
}
    `);
export const GetRestockSessionKitsDocument = new TypedDocumentString(`
    query GetRestockSessionKits($sessionId: String!) {
  restockSession(sessionId: $sessionId) {
    sessionId
    sessionName
    status
    kits {
      ...RestockSessionKit
    }
  }
}
    fragment RestockSessionKitLine on RestockSessionKitLineData {
  lineId
  kind
  refId
  multiple
  label
  secondaryLabel
  unit {
    shippingUomId
    shippingUomCode
    eachesPerUnit
  }
}
fragment RestockSessionKit on RestockSessionKitData {
  kitId
  siteIds
  definitions {
    kitId
    name
    containerCode
    sourceUpdatedAt
    lines {
      ...RestockSessionKitLine
    }
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetRestockSessions: build.query<GetRestockSessionsQuery, GetRestockSessionsQueryVariables | void>({
      query: (variables) => ({ document: GetRestockSessionsDocument, variables })
    }),
    GetRestockSession: build.query<GetRestockSessionQuery, GetRestockSessionQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionDocument, variables })
    }),
    GetRestockSessionCalcStatus: build.query<GetRestockSessionCalcStatusQuery, GetRestockSessionCalcStatusQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionCalcStatusDocument, variables })
    }),
    GetRestockSessionOrderItems: build.query<GetRestockSessionOrderItemsQuery, GetRestockSessionOrderItemsQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionOrderItemsDocument, variables })
    }),
    GetRestockSessionOrderItemsBlock: build.query<GetRestockSessionOrderItemsBlockQuery, GetRestockSessionOrderItemsBlockQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionOrderItemsBlockDocument, variables })
    }),
    GetRestockSessionRowCalcSteps: build.query<GetRestockSessionRowCalcStepsQuery, GetRestockSessionRowCalcStepsQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionRowCalcStepsDocument, variables })
    }),
    GetRestockFullCartPreview: build.query<GetRestockFullCartPreviewQuery, GetRestockFullCartPreviewQueryVariables>({
      query: (variables) => ({ document: GetRestockFullCartPreviewDocument, variables })
    }),
    GetRestockRowExplanation: build.query<GetRestockRowExplanationQuery, GetRestockRowExplanationQueryVariables>({
      query: (variables) => ({ document: GetRestockRowExplanationDocument, variables })
    }),
    GetRestockSessionCreationExclusions: build.query<GetRestockSessionCreationExclusionsQuery, GetRestockSessionCreationExclusionsQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionCreationExclusionsDocument, variables })
    }),
    GetRestockSessionOrderQuantityOverrideHistory: build.query<GetRestockSessionOrderQuantityOverrideHistoryQuery, GetRestockSessionOrderQuantityOverrideHistoryQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionOrderQuantityOverrideHistoryDocument, variables })
    }),
    GetRestockSessionSubmitSummary: build.query<GetRestockSessionSubmitSummaryQuery, GetRestockSessionSubmitSummaryQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionSubmitSummaryDocument, variables })
    }),
    GetRestockSessionKits: build.query<GetRestockSessionKitsQuery, GetRestockSessionKitsQueryVariables>({
      query: (variables) => ({ document: GetRestockSessionKitsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetRestockSessionsQuery, useLazyGetRestockSessionsQuery, useGetRestockSessionQuery, useLazyGetRestockSessionQuery, useGetRestockSessionCalcStatusQuery, useLazyGetRestockSessionCalcStatusQuery, useGetRestockSessionOrderItemsQuery, useLazyGetRestockSessionOrderItemsQuery, useGetRestockSessionOrderItemsBlockQuery, useLazyGetRestockSessionOrderItemsBlockQuery, useGetRestockSessionRowCalcStepsQuery, useLazyGetRestockSessionRowCalcStepsQuery, useGetRestockFullCartPreviewQuery, useLazyGetRestockFullCartPreviewQuery, useGetRestockRowExplanationQuery, useLazyGetRestockRowExplanationQuery, useGetRestockSessionCreationExclusionsQuery, useLazyGetRestockSessionCreationExclusionsQuery, useGetRestockSessionOrderQuantityOverrideHistoryQuery, useLazyGetRestockSessionOrderQuantityOverrideHistoryQuery, useGetRestockSessionSubmitSummaryQuery, useLazyGetRestockSessionSubmitSummaryQuery, useGetRestockSessionKitsQuery, useLazyGetRestockSessionKitsQuery } = injectedRtkApi;
